import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

const OutputHeader = () => {
  return (
    <Grid
      size={{ xs: 12 }}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
      }}
    >
      <Typography
        variant="h5"
        sx={{ color: '#1e293b' }}
      >
        <strong>Proposal Outputs</strong>
      </Typography>

      <Typography
        color="text.secondary"
      >
        Review each section, optionally make edits, and score it before saving or uploading.
      </Typography>

      <Divider
        sx={{
          width: '100%',
          borderColor: '#e2e8f0',
          borderBottomWidth: '2px',
          mt: 1,
        }}
      />
    </Grid>
  );
};

export default OutputHeader;